import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { App } from "./App.js"
import { AnimTestScreen } from "./screens/AnimTestScreen.js"

// Initialize Telegram Mini App
if (window.Telegram?.WebApp) {
  window.Telegram.WebApp.ready()
  window.Telegram.WebApp.expand()
  window.Telegram.WebApp.setHeaderColor("#0a0a0f")
  window.Telegram.WebApp.setBackgroundColor("#0a0a0f")
}

const root = document.getElementById("root")!
const isAnimTest = window.location.pathname === "/anim-test"

createRoot(root).render(
  <StrictMode>
    {isAnimTest ? (
      <AnimTestScreen />
    ) : (
      <BrowserRouter>
        <App />
      </BrowserRouter>
    )}
  </StrictMode>
)
